import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector, TypedUseSelectorHook } from 'react-redux';
import reducers from './reducers';
import { airflowApi } from './airflow/airflowSlice';
import { stagingApi } from './staging/stagingSlice';
import { transferApi } from './transfer/transferSlice';
import { userOrgApi } from './userOrg/userOrgSlice';
import { airflowApiQueryErrorLogger } from './airflow/airflowApiQueryErrorLogger';
import { userOrgApiQueryErrorLogger } from './userOrg/userOrgApiQueryErrorLogger';
import { metadataApi } from './metadata/metadataSlice';
import { transferApiQueryErrorLogger } from './transfer/transferApiQueryErrorLogger';
import { stagingApiQueryErrorLogger } from './staging/stagingApiQueryErrorLogger';
import { metadataApiQueryErrorLogger } from './metadata/metadataApiQueryErrorLogger';
import { workflowLWDsApi } from './workflowLWDs/workflowLWDsSlice';
import { workflowLWDApiQueryErrorLogger } from './workflowLWDs/workflowLWDsApiQueryErrorLogger';
import { expirioApi } from './expirio/expirioSlice';
import { expirioApiQueryErrorLogger } from './expirio/expirioApiQueryErrorLogger';

const store = configureStore({
    reducer: reducers,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({ serializableCheck: false }).concat([
            airflowApi.middleware,
            userOrgApi.middleware,
            airflowApi.middleware,
            metadataApi.middleware,
            stagingApi.middleware,
            transferApi.middleware,
            workflowLWDsApi.middleware,
            expirioApi.middleware,

            transferApiQueryErrorLogger,
            stagingApiQueryErrorLogger,
            metadataApiQueryErrorLogger,
            airflowApiQueryErrorLogger,
            userOrgApiQueryErrorLogger,
            workflowLWDApiQueryErrorLogger,
            expirioApiQueryErrorLogger,
        ]),
});

export type RootState = ReturnType<typeof reducers>;

export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

const useDispatch = () => useAppDispatch<AppDispatch>();
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { store, dispatch, useSelector, useDispatch };
